module.exports = __webpack_public_path__ + "img/BF.bd5be031.svg";